(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/cloud-api/assets/javascripts/cloud-api-constants.js') >= 0) return;  svs.modules.push('/components/lb-utils/cloud-api/assets/javascripts/cloud-api-constants.js');
"use strict";


const cloudApiFeatureToggles = {
  BOMBEN: 'ft-use-draw-proxy-bomben-cloud-api',
  MATCHEN: 'ft-use-draw-proxy-matchen-cloud-api',
  EUROPATIPSET: 'ft-use-draw-proxy-europatipset-cloud-api',
  STRYKTIPSET: 'ft-use-draw-proxy-stryktipset-cloud-api'
};
const VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT = [7]; 

const cloudApiConstants = {
  cloudApiFeatureToggles,
  VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT
};
if (svs.isServer) {
  module.exports = cloudApiConstants;
} else {
  setGlobal('svs.components.lbUtils.cloudApi.cloudApiConstants', cloudApiConstants);
}

 })(window);